import {useEffect, useState} from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 *
 * Schedule builder logic for the work shift "schedules" section. In both create
 * and update the applied schedules are buffered client-side via setSchedules and
 * only persisted when the user submits (create / update), so leaving, reloading
 * or closing the screen does not commit anything.
 *
 * @param {number|string|null|undefined} id - Work shift id; absent in create.
 * @param {Array<Object>} [schedules] - Client-side schedule buffer.
 * @param {Function} [setSchedules] - Buffer setter.
 */
const WorkShiftAccessCardApp = ({ id, schedules, setSchedules, triggerClear, setTriggerClear }) => {
    const { t } = useTranslation();

    const [fromValue, setfromValue] = useState(null);
    const [toValue, setToValue] = useState(null);
    const [, setAllDays] = useState(false);
    const [allTime, setAllTime] = useState(false);
    const [checked, setChecked] = useState([]);
    const [dayArray, setDayArray] = useState([]);
    const [disabled, setDisabled] = useState(true);
    const [array, setArray] = useState([]);
    const [emptyFields, setEmptyFields] = useState(false);

    useEffect(()=>{
        setDisabled(!fromValue || !toValue || checked.length === 0 || dayArray.length === 0)
    },[fromValue,toValue,checked,dayArray])

    /**
     * Resets the schedule builder: zone checkboxes + day/time picker.
     */
    const resetPicker = () => {
        setChecked([]);
        setArray([]);
        setDayArray([]);
        setEmptyFields(false);
        setAllTime(false);
        setfromValue(null);
        setToValue(null);
    };

    // Parent "clear section" button raises triggerClear; wipe the picker too.
    useEffect(() => {
        if (triggerClear) {
            resetPicker();
            setTriggerClear?.(false);
        }
    }, [triggerClear]);

    // Function to handle the checkbox selection
    const handleCheck = (event) => {
        let updatedList = [...checked];
        if (event.target.checked) {
            updatedList = [...checked, event.target.value];
        } else {
            updatedList.splice(checked.indexOf(event.target.value), 1);
        }
        setChecked(updatedList);
    };

    // Function to handle the form submission aply selected
    const handleCLick = async () => {
        if (!fromValue || !toValue || checked.length === 0 || dayArray.length === 0) {
            setEmptyFields(true)
            toast.warn(t('please_fill_all_fields'));
            return;
        }
        let updateArray = [...array];
        for (let i = 0; i < checked.length; i++) {
            for (let j = 0; j < dayArray.length; j++) {
                let x = {
                    zone: { id: checked[i] },
                    day: { id: dayArray[j] },
                    from: moment(fromValue).format('HH:mm:ss'),
                    to: moment(toValue).format('HH:mm:ss'),
                };
                updateArray.push(x);
            }
        }
        setArray(updateArray);

        // Buffer the schedules client-side; submitted on create / update.
        const buffered = updateArray.map((item, index) => {
            // The checked value is "id,name"; derive both parts from it.
            const [zoneId, ...nameParts] = `${item?.zone?.id}`.split(',');
            const zoneName = nameParts.join(',') || zoneId;
            const tempId = `${zoneId}-${item?.day?.id}-${item?.from}-${item?.to}-${index}-${Date.now()}`;
            return {
                id: tempId,
                tempId,
                dayId: item?.day?.id,
                from: item?.from,
                to: item?.to,
                zoneId,
                zoneName,
            };
        });
        setSchedules?.(prev => [...(prev || []), ...buffered]);
        resetPicker();
    };

    return {
        fromValue,
        setfromValue,
        toValue,
        setToValue,
        setAllDays,
        allTime,
        setAllTime,
        checked,
        setChecked,
        dayArray,
        setDayArray,
        handleCheck,
        handleCLick,
        emptyFields,
        disabled
    };
};

export default WorkShiftAccessCardApp;
